module.exports = __webpack_public_path__ + "static/media/warning_red.0aedf72f.png";